import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { CommonUtilitiesService } from '../common-utilities.service';
import { constants } from '../../app/constants';

@Component({
  selector: 'app-payment-view-urlok-recurrent',
  templateUrl: './payment-view-urlok-recurrent.component.html',
  styleUrls: ['./payment-view-urlok-recurrent.component.scss']
})
export class PaymentViewUrlokRecurrentComponent implements OnInit {

  numberMaxi = "";
  rechargeAmount = "";
  cCard = "";
  authNumber = "";
  txNumber = "";
  isComboInCart = true;


  // isComboInCart = true;
  currentCombo = null;
  idPackageDesc = "";
  validityCombon: any = "";
  packageCode:any = "";
  paymentId = "";


  catBra = constants.COMBO_CATEGORY_BRAND;
  catMou = constants.COMBO_CATEGORY_MOUNT;
  catExp = constants.COMBO_CATEGORY_EXPRESS;

  
  constructor(public LANG: CommonUtilitiesService, private route: ActivatedRoute) { }

  ngOnInit() {
    
    //se obtiene el combo/bono en cuestion
    this.currentCombo = JSON.parse(localStorage.getItem("shoppingCart"));

    //si es bono
    if (this.currentCombo.bonuses == null || typeof this.currentCombo.bonuses === 'undefined') {
      this.isComboInCart = false;
      this.idPackageDesc = this.currentCombo.commercialDescription;
      this.validityCombon = this.currentCombo.validityDays + " " + this.currentCombo.validityType;
      this.packageCode = this.currentCombo.idSlo;
      this.currentCombo.nslist = this.currentCombo.socialNet.split("-");      
      this.paymentId = this.currentCombo.idPaymentManager;
    } else {
      //si es combo
      this.validityCombon = this.currentCombo.validity + " " + this.LANG.getLangText("COMBOS_HOME_VALIDITY_DAYS");
      this.packageCode = this.currentCombo.slo;
      this.paymentId = this.currentCombo.idPaymentManager;
      //para obtener la descripcion commercial del bono principal
      for (let k in this.currentCombo.bonuses) {
        if (this.currentCombo.bonuses[k].isMain == 'S') {
          this.idPackageDesc = this.currentCombo.bonuses[k].commercialDescription;
          break;
        }
      }
    }

    //atributos columna 
    let _self = this;
    this.route.params.subscribe(params => this.setErrorParams(params));
    document.getElementById('pay-rs').scrollIntoView();
  }

  setErrorParams(params) {

    this.numberMaxi = params.numberMaxi;
    this.rechargeAmount = params.rechargeAmount;
    this.cCard = params.cCard;
    this.authNumber = params.authNumber;
    this.txNumber = params.txNumber;
  }

}
